import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import Context from '@bibliocommons/context';

export default class FeatureTogglz extends React.Component {
  render() {
    return this.props.children(this.context.features || Immutable.Map());
  }
}

FeatureTogglz.contextType = Context;

FeatureTogglz.propTypes = {
  children: PropTypes.func.isRequired
};
